import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import CustomSpinner from '../../components/CustomSpinner';
import { getBusinessMeRequest, getBusinessQrRequest } from '../../actions/index';

class BusinessQR extends Component {
  static propTypes = {
    getMe: PropTypes.func.isRequired,
    getQr: PropTypes.func.isRequired,
    loadingProfile: PropTypes.bool,
    loadingQr: PropTypes.bool,
    profile: PropTypes.shape({ id: PropTypes.string, status: PropTypes.string }),
    qr: PropTypes.shape({ businessName: PropTypes.string, qrData: PropTypes.string }),
  };

  componentDidMount() {
    const { profile, getMe } = this.props;
    if (!profile) {
      getMe();
    } else {
      this.props.getQr(profile.id);
    }
  }

  componentDidUpdate(prevProps) {
    const { profile, qr, getQr } = this.props;
    if (profile && !prevProps.profile && !qr) {
      getQr(profile.id);
    }
  }

  downloadQr = () => {
    const { qr } = this.props;
    if (!qr) return;
    const url = this.qrImageUrl(qr.qrData);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'yieldbucks-qr.png';
    a.target = '_blank';
    a.click();
  };

  qrImageUrl(data) {
    return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
      data,
    )}`;
  }

  render() {
    const { qr, loadingQr, loadingProfile, profile } = this.props;

    if (loadingQr || loadingProfile) return <CustomSpinner />;

    if (profile && profile.status !== 'active') {
      return (
        <Container className="pt-5">
          <Alert variant="warning">
            Your QR code will be available once your account is approved by our team.
          </Alert>
        </Container>
      );
    }

    return (
      <Container className="pt-5">
        <Row>
          <Col xs={12}>
            <h1 className="h1-list">QR Code</h1>
            <p className="text-muted">
              Display this QR code in your business so customers can scan it with the YieldBucks app
              to redeem rewards.
            </p>
          </Col>

          {qr ? (
            <Col xs={12} md={6} lg={4} className="mt-4">
              <Card className="text-center p-3">
                <Card.Title>{qr.businessName}</Card.Title>
                <Card.Body>
                  <img
                    src={this.qrImageUrl(qr.qrData)}
                    alt="YieldBucks QR Code"
                    style={{ width: '100%', maxWidth: 300, border: '1px solid #eee', padding: 8 }}
                  />
                  <div className="mt-3">
                    <small className="text-muted d-block mb-2">{qr.qrData}</small>
                    <Button variant="primary" onClick={this.downloadQr}>
                      Download QR Code
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ) : (
            !loadingQr && (
              <Col xs={12} className="mt-4">
                <Alert variant="warning">Unable to load QR code. Please refresh.</Alert>
              </Col>
            )
          )}
        </Row>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.business.profile,
    loadingProfile: state.business.loadingProfile,
    qr: state.business.qr,
    loadingQr: state.business.loadingQr,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getMe: () => dispatch(getBusinessMeRequest()),
    getQr: businessId => dispatch(getBusinessQrRequest(businessId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessQR);
